export default {
    common: {
        email: 'Email',
        password: 'Password',
        passwordConfirmation: 'Confirm password',
        name: 'Name',
        save: 'Save',
        cancel: 'Cancel',
        edit: 'Edit',
        delete: 'Delete',
        create: 'Create',
        back: 'Back',
        close: 'Close',
        yes: 'Yes',
        no: 'No',
        loading: 'Loading…',
        actions: 'Actions',
        saving: 'Saving...',
        creating: 'Creating...',
        saved: 'Saved.',
    },
    nav: {
        dashboard: 'Dashboard',
        invoices: 'Invoices',
        recipients: 'Clients',
        automatizations: 'Automatizations',
        profile: 'Profile',
        logout: 'Log out',
        openMenu: 'Open menu',
        admin: 'Admin',
    },
    auth: {
        login: {
            title: 'Login',
            password: 'Password',
            rememberMe: 'Remember me',
            noAccount: "Don't have an account?",
            forgotPassword: 'Forgot your password?',
            submit: 'Log in',
        },
        register: {
            title: 'Register',
            hasAccount: 'Already have an account?',
            submit: 'Register',
        },
        forgotPassword: {
            title: 'Forgot password',
            description: "Forgot your password? No problem. Just let us know your email address and we will email you a password reset link.",
            submit: 'Email password reset link',
        },
        resetPassword: {
            title: 'Reset password',
            submit: 'Reset password',
        },
        confirmPassword: {
            title: 'Confirm password',
            description: 'This is a secure area of the application. Please confirm your password before continuing.',
            submit: 'Confirm',
        },
        verifyEmail: {
            title: 'Verify email',
            description: "Thanks for signing up! Before getting started, please verify your email address by clicking the link we just emailed to you. If you didn't receive the email, we will gladly send you another.",
            linkSent: 'A new verification link has been sent to the email address you provided during registration.',
            submit: 'Resend verification email',
        },
    },
    invoiceStatus: {
        draft: 'Draft',
        sent: 'Sent',
        paid: 'Paid',
        overdue: 'Overdue',
    },
    dashboard: {
        title: 'Dashboard',
        welcomeBack: 'Welcome back, {name}.',
        stats: {
            invoices: 'Invoices',
            clients: 'Clients',
            automatizationsActive: 'Active automatizations',
            totalInSystem: 'total in the system',
            runAutomatically: 'run automatically',
        },
        pie: {
            title: 'Invoiced by status',
            subtitle: 'Breakdown of total invoiced amount',
            empty: "You don't have any amounts to break down yet.",
            invoiced: 'invoiced',
            paid: 'Paid',
            awaiting: 'Awaiting payment',
            overdue: 'Overdue',
            draft: 'Draft',
        },
        overview: {
            totalInvoiced: 'Invoiced',
            paid: 'Paid',
            awaiting: 'Awaiting payment',
            overdue: 'Overdue',
        },
        recentInvoices: {
            title: 'Recent invoices',
            viewAll: 'View all',
            empty: "There are no invoices here yet.",
        },
        activeAutomatizations: {
            title: 'Active automatizations',
            manage: 'Manage',
            empty: "You don't have any active automatizations yet.",
            allClients: 'For all clients',
            next: 'Next',
            active: 'Active',
        },
    },
    automatizations: {
        pageTitle: 'Automatizations',
        newAutomatization: 'New automatization',
        emptyState: "You don't have any automatizations yet. Create one to automatically generate invoices or send a monthly report.",
        backToAutomatizations: 'Back to automatizations',
        deleteConfirm: 'Delete automatization "{label}"?',
        list: {
            type: 'Type',
            client: 'Client',
            nextRun: 'Next run',
            status: 'Status',
            active: 'Active',
            inactive: 'Inactive',
            activate: 'Activate',
            deactivate: 'Deactivate',
        },
        form: {
            newTitle: 'New automatization',
            editTitle: 'Edit automatization',
            modalDescription: 'Configure automatic actions for your invoices.',
            typeSection: 'Automatization type',
            settingsSection: 'Settings',
            type: 'Type',
            typeLabel: 'Type:',
            itemCount: 'Number of items on the invoice',
            itemNames: 'Item names',
            client: 'Client',
            selectClient: 'Select a client',
            firstRunDate: 'First run date',
            reportHint: 'The report covers the previous month from this date.',
            dailyHint: 'This automatization runs daily starting today.',
            dueOffsetDays: 'Days before/after due date',
            dueOffsetHintBefore: '- before due date',
            dueOffsetHintAfter: '+ after due date',
            dueOffsetHintOnDate: '0 on the due date',
            active: 'Active',
            saveAutomatization: 'Save',
            createAutomatization: 'Create automatization',
        },
    },
    invoices: {
        pageTitle: 'Invoices',
        newInvoice: 'New invoice',
        backToInvoices: 'Back to invoices',
        table: {
            number: 'Invoice number',
            client: 'Client',
            created: 'Created',
            amount: 'Amount',
            status: 'Status',
            downloadPdf: 'Download PDF',
            empty: "You don't have any invoices yet.",
            deleteConfirm: 'Delete invoice {number}?',
        },
        header: {
            title: 'Invoice',
            description: 'Number, variable symbol and dates.',
            number: 'Invoice number',
            variableSymbol: 'Variable symbol',
            issueDate: 'Issue date',
            dueDate: 'Due date',
            currency: 'Currency',
        },
        sections: {
            basicData: 'Basic details',
            client: 'Client',
            items: 'Invoice items',
        },
        recipient: {
            title: 'Client',
            selectClient: 'Select a client',
            startTyping: 'Start typing...',
            addNewClient: '+ Add a new client',
            descriptionEdit: 'Search and select a client, or edit the details below.',
            descriptionCreate: 'Search and select a client, or add a new one.',
        },
        items: {
            title: 'Invoice items',
            description: 'Add one or more items with a name, quantity, unit and price.',
            addItem: 'Add item',
            name: 'Name',
            quantity: 'Quantity',
            unit: 'Unit',
            unitPrice: 'Unit price',
            vatType: 'VAT type',
            amountExclVat: 'Amount excl. VAT',
            vat: 'VAT',
            total: 'Total',
            remove: 'Remove',
            removeRow: 'Remove row',
            subtotal: 'Subtotal (excl. VAT)',
            vatBase: 'VAT base:',
            vatLabel: 'VAT:',
            flatDescription: 'Item description',
            qtyShort: 'Qty.',
            unitShort: 'Unit',
            unitShortMobile: 'Unit',
            pricePerUnit: 'Price / unit',
            totalShort: 'Total',
        },
        issuer: {
            title: 'Billing details',
            description: "Issuer's address on the invoice.",
            name: 'Name / company',
            companyRegNo: 'Company Reg. No.',
            taxId: 'Tax ID',
            vatId: 'VAT ID',
            street: 'Street',
            streetNum: 'Street number',
            city: 'City',
            zip: 'Zip code',
            country: 'Country',
            selectCountry: 'Select a country',
        },
        settings: {
            logoUploaded: 'Logo uploaded',
            noLogo: 'No logo',
            uploadHint: 'Click the area to choose a file.',
            removeLogo: 'Remove logo',
            noLogoInvoiceHint: 'No logo. Add one in your profile under Invoice settings.',
            companyLogoAlt: 'Company logo',
        },
        form: {
            newInvoice: 'New invoice',
            editInvoice: 'Edit invoice {number}',
            saveInvoice: 'Save invoice',
            createInvoice: 'Create invoice',
        },
    },
    recipients: {
        pageTitle: 'Clients',
        newClient: 'New client',
        totalCount: '{count} clients total',
        searchPlaceholder: 'Search clients...',
        backToRecipients: 'Back to clients',
        table: {
            client: 'CLIENT',
            ico: 'REG. NO.',
            city: 'CITY',
            invoices: 'INVOICES',
            invoiced: 'INVOICED',
            noResults: 'No client matches your search.',
            empty: "You don't have any clients yet.",
            deleteConfirm: 'Delete "{name}"?',
        },
        card: {
            city: 'City',
            street: 'Street',
            streetNum: 'Number',
        },
        details: {
            sectionTitle: 'Client details',
            sectionDescription: "Client's name, address and identifiers.",
            name: 'Name / business name',
            street: 'Street',
            streetNum: 'Street number',
            city: 'City',
            zip: 'Zip code',
            country: 'Country',
            stateOrZip: 'State / zip code',
            ico: 'Company Reg. No.',
            dic: 'Tax ID',
            icDph: 'VAT ID',
            iban: 'IBAN',
            selectCountry: 'Select a country',
        },
        modal: {
            newTitle: 'New client',
            editTitle: 'Edit client',
            description: 'Enter billing and contact details.',
            companyDetails: 'Company details',
            address: 'Address',
            companyName: 'Company name',
            email: 'Email',
            icDphHint: 'Only fill in if the company is a VAT payer.',
        },
        form: {
            newTitle: 'New client',
            editTitle: 'Edit: {name}',
            defaultName: 'Client',
            saveClient: 'Save client',
            createClient: 'Create client',
        },
    },
    profile: {
        pageTitle: 'Profile',
        billing: {
            title: 'Billing details',
            description: "Issuer's details on invoices (address, identifiers, payment account).",
            defaultCurrency: 'Default currency',
            defaultVatType: 'Default VAT type',
        },
        invoiceSettings: {
            title: 'Invoice settings',
            description: 'Logo shown on PDF invoices.',
        },
        deleteAccount: {
            title: 'Delete account',
            description: 'Once your account is deleted, all of its data will be permanently removed. Please download any data you wish to keep before deleting.',
            button: 'Delete account',
            confirmTitle: 'Are you sure you want to delete your account?',
            confirmDescription: 'Once your account is deleted, all of its data will be permanently removed. Enter your password to confirm you would like to permanently delete your account.',
            passwordPlaceholder: 'Password',
        },
        password: {
            title: 'Change password',
            description: 'Use a long, random password to stay secure.',
            current: 'Current password',
            new: 'New password',
        },
        info: {
            title: 'Profile information',
            description: "Update your account's name and email address.",
            emailUnverified: 'Your email address is unverified.',
            resendVerification: 'Click here to re-send the verification email.',
            verificationSent: 'A new verification link has been sent to your email address.',
        },
    },
    welcome: {
        headTitle: 'Invoicius – simple invoicing',
        login: 'Log in',
        hero: {
            titleLine1: 'Invoices, clients',
            titleLine2: 'and automatizations',
            titleHighlight: 'all in one place',
            subtitle: 'Create invoices, manage clients, and automate recurring tasks — without the busywork.',
            cta: 'Log in to the app',
            tagline: 'Simple invoicing · VAT · PDF export · Automatizations',
            screenshotAlt: 'Preview of the Invoicius app',
            slideAriaLabel: 'Slide {n}',
        },
        trust: {
            invoiceReady: 'Invoice ready in 2 minutes',
            localization: 'Multiple currencies & languages',
            pdfExport: 'Export invoices anytime',
            automation: 'Automatizations run around the clock',
        },
        features: {
            title: 'Everything you need for invoicing',
            subtitle: 'No unnecessary features. Just what you actually use every day.',
            invoices: {
                title: 'Invoices',
                description: 'Issue an invoice in a minute. Track every status — from draft to paid.',
                item1: 'Export to PDF anytime',
                item2: 'Items with VAT and discounts',
                item3: 'Real-time payment status',
            },
            clients: {
                title: 'Clients',
                description: 'Manage clients including registration number, tax ID, address, and full billing history.',
                item1: 'Complete billing details',
                item2: 'Invoice history per client',
                item3: 'Total revenue in one place',
            },
            automatizations: {
                title: 'Automatizations',
                description: 'Set it up once, the system works for you — monthly invoices, reports, reminders.',
                item1: 'Automatic invoice generation',
                item2: 'Monthly reports by email',
                item3: 'Reminders before the due date',
            },
        },
        cta: {
            titleLine1: 'Start',
            titleLine2: 'invoicing',
            titleHighlight: 'today',
            description: 'Log in and manage your invoicing clearly, quickly, and without the busywork.',
            button: 'Log in',
            tileInvoiceReady: 'Invoice in 2 minutes',
            tileLocalization: 'Multiple currencies & languages',
            tilePdfExport: 'Export anytime',
            tileAutomation: 'Automatizations around the clock',
        },
        footer: 'Invoicius · 2026',
    },
    units: {
        pcs: 'pcs',
        hrs: 'hrs',
        days: 'days',
        kg: 'kg',
        m: 'm',
        m2: 'm²',
    },
    vatType: {
        mimo: 'Outside VAT',
        osvo: 'VAT exempt',
    },
    currency: {
        '€': 'Euro',
        'Kč': 'Czech koruna',
        '$': 'US dollar',
    },
} as const;
